import { RiEyeLine, RiEyeOffLine, RiLoader4Line } from 'react-icons/ri';
import { parseHostInput } from '../utils/connection';

const NewLoginModal = ({
  open = false,
  loginDraft,
  setLoginDraft,
  showPassword,
  setShowPassword,
  connecting = false,
  onCancel,
  onConnect,
  onSaveAndConnect
}) => {
  if (!open) return null;

  const disabled =
    connecting ||
    !loginDraft?.host ||
    !loginDraft?.port ||
    !loginDraft?.username ||
    !loginDraft?.password;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 p-4 backdrop-blur">
      <div className="glass-panel w-full max-w-2xl rounded-2xl p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-xs font-semibold text-textMuted">New login</p>
            <h3 className="text-lg font-semibold text-white m-0">Connect to server</h3>
          </div>
          <button type="button" className="ghost-button" onClick={onCancel}>
            Close
          </button>
        </div>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
          <select
            className="rounded-lg border border-border bg-inset/60 px-3 py-2 text-sm text-white focus:border-accent focus:outline-none"
            value={loginDraft.protocol || 'sftp'}
            onChange={(e) => {
              const nextProtocol = e.target.value;
              setLoginDraft((prev) => {
                const nextPort =
                  nextProtocol === 'ftps' ?
                    prev.port === 2022 ? 21 : prev.port || 21 :
                    prev.port === 21 ? 2022 : prev.port || 2022;
                return { ...prev, protocol: nextProtocol, port: nextPort };
              });
            }}>
            <option value="sftp">SFTP</option>
            <option value="ftps">FTPS</option>
          </select>
          <input
            className="rounded-lg border border-border bg-inset/60 px-3 py-2 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none"
            placeholder="Server address"
            value={loginDraft.host}
            autoFocus
            onChange={(e) => {
              const raw = e.target.value;
              const parsed = parseHostInput(raw, loginDraft.protocol);
              setLoginDraft((prev) => ({
                ...prev,
                host: parsed.host || raw,
                protocol: parsed.host ? parsed.protocol : prev.protocol,
                port: parsed.port ?? prev.port
              }));
            }}
            onBlur={(e) => {
              const raw = e.target.value;
              const parsed = parseHostInput(raw, loginDraft.protocol);
              if (!parsed.host) return;
              setLoginDraft((prev) => ({
                ...prev,
                host: parsed.host,
                protocol: parsed.protocol,
                port: parsed.port ?? prev.port
              }));
            }} />

          <input
            className="rounded-lg border border-border bg-inset/60 px-3 py-2 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none"
            placeholder="Port"
            type="number"
            value={loginDraft.port}
            onChange={(e) => setLoginDraft((prev) => ({ ...prev, port: Number(e.target.value) }))} />

          <input
            className="rounded-lg border border-border bg-inset/60 px-3 py-2 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none"
            placeholder="Username"
            value={loginDraft.username}
            onChange={(e) => setLoginDraft((prev) => ({ ...prev, username: e.target.value }))} />

          <div className="md:col-span-2 relative">
            <input
              className="w-full rounded-lg border border-border bg-inset/60 px-3 py-2 pr-8 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none"
              placeholder="Password"
              type={showPassword ? 'text' : 'password'}
              value={loginDraft.password}
              onChange={(e) => setLoginDraft((prev) => ({ ...prev, password: e.target.value }))} />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              className="absolute right-2.5 top-1/2 -translate-y-1/2 text-textMuted hover:text-white window-no-drag"
              tabIndex={-1}>
              {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
            </button>
          </div>
        </div>
        <div className="mt-4 flex flex-wrap justify-end gap-2">
          <button type="button" className="ghost-button" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="ghost-button"
            onClick={onConnect}
            disabled={disabled}>
            {connecting ? <span className="flex items-center gap-2"><RiLoader4Line className="animate-spin" /> Connecting...</span> : 'Connect'}
          </button>
          <button
            type="button"
            className="pill-button px-4 py-2"
            onClick={onSaveAndConnect}
            disabled={disabled}>
            Save & Connect
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewLoginModal;
